PegasusTemplate.EditingMixin = Ember.Mixin.create({
  click: function(){
    // TODO change to menu state ?
    return false;
  },

  // derived class should define a constructor class for editing
  copyConstructor: Em.View,

  copy: function(){
    return this.get('copyConstructor').create({
      controller: this.get('controller'),
      context: this.get('context')
    });
  }
});

